import { render, staticRenderFns } from "./FormOverlay.vue?vue&type=template&id=5b7502ce&"
import script from "./FormOverlay.vue?vue&type=script&lang=ts&"
export * from "./FormOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports